"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCurrentCardiologicalState = createCurrentCardiologicalState;
const events_1 = require("../../../events");
const _6Mwt_1 = require("../../../forms/htx/current-cardiological-state/6Mwt");
const nyha_1 = require("../../../forms/htx/current-cardiological-state/nyha");
const pacemakerTherapy_1 = require("../../../forms/htx/current-cardiological-state/pacemakerTherapy");
const common_1 = require("../../../utils/common");
const shared_1 = require("../../shared");
const queries_1 = require("../queries");
const createCardiopulmonaryStressTest_1 = require("./createCardiopulmonaryStressTest");
const createEchoCardiography_1 = require("./createEchoCardiography");
const createEkg_1 = require("./createEkg");
const createHeartAssistSystemTherapy_1 = require("./createHeartAssistSystemTherapy");
const createHeartFailureMedicalTherapy_1 = require("./createHeartFailureMedicalTherapy");
const createRightHeartCatherization_1 = require("./createRightHeartCatherization");
const createVitalSigns_1 = require("./createVitalSigns");
const messages = {
    currentCardiologicalState: {
        id: "dashboard.current_cardiological_state",
        defaultMessage: "Aktuális kardiológiai állapot"
    },
    functionalState: {
        id: "dashboard.functional_state",
        defaultMessage: "Funkcionális állapot"
    },
    nyha: {
        id: "dashboard.nyha",
        defaultMessage: "NYHA"
    },
    notAbleTo6mwt: {
        id: "dashboard.not_able_to_6mwt",
        defaultMessage: "Nem alkalmas"
    },
    "6mwt": {
        id: "dashboard.6mwt",
        defaultMessage: "6MWT"
    },
    hospitalizations: {
        id: "dashboard.hospitalizations",
        defaultMessage: "HF hospitalizáció"
    },
    pacemakerTherapy: {
        id: "dashboard.pacemaker_therapy",
        defaultMessage: "Pacemaker kezelés"
    },
    coronarography: {
        id: "dashboard.coronarography",
        defaultMessage: "Coronarográfia"
    },
    cCt: {
        id: "dashboard.c_ct",
        defaultMessage: "Szív CT vizsgálat"
    },
    cMri: {
        id: "dashboard.c_mri",
        defaultMessage: "Szív MRI"
    },
    spect: {
        id: "dashboard.spect",
        defaultMessage: "SPECT"
    },
    cPet: {
        id: "dashboard.c_pet",
        defaultMessage: "Szív PET vizsgálat"
    }
};
function createCurrentCardiologicalState(intl, options) {
    const functionalState = createFunctionalState(intl, options);
    const ekg = (0, createEkg_1.createEkg)(intl, options);
    const echoCardiography = (0, createEchoCardiography_1.createEchoCardiography)(intl, options);
    const pacemakerTherapy = createPacemakerTherapy(intl, options);
    const heartAssistSystemTherapy = (0, createHeartAssistSystemTherapy_1.createHeartAssistSystemTherapy)(intl, options);
    const rightHeartCatherization = (0, createRightHeartCatherization_1.createRightHeartCatherization)(intl, options);
    const heartFailueMedicalTherapy = (0, createHeartFailureMedicalTherapy_1.createHeartFailueMedicalTherapy)(intl, options);
    const coronarography = createCoronarography(intl, options);
    const cCt = createCCt(intl, options);
    const cMri = createCMri(intl, options);
    const spect = createSpect(intl, options);
    const cPet = createCPet(intl, options);
    const content = (0, shared_1.createSectionContent)([
        functionalState,
        ekg,
        echoCardiography,
        pacemakerTherapy,
        heartAssistSystemTherapy,
        rightHeartCatherization,
        heartFailueMedicalTherapy,
        coronarography,
        cCt,
        cMri,
        spect,
        cPet
    ]);
    return (0, shared_1.createSection)(intl, {
        label: messages.currentCardiologicalState,
        content
    });
}
function createFunctionalState(intl, options) {
    const nyha = createNyha(intl, options);
    const $6mwt = create6mwt(intl, options);
    const cardiopulmonaryStressTest = (0, createCardiopulmonaryStressTest_1.createCardiopulmonaryStressTest)(intl, options);
    const vitalSigns = (0, createVitalSigns_1.createVitalSigns)(intl, options);
    const hospitalizations = createHospitalizations(intl, options);
    const content = (0, shared_1.createGroupContent)([
        nyha,
        $6mwt,
        cardiopulmonaryStressTest,
        vitalSigns,
        hospitalizations
    ]);
    return (0, shared_1.createGroup)(intl, {
        variant: "dark",
        label: messages.functionalState,
        content
    });
}
function createNyha(intl, { events }) {
    return (0, shared_1.createFormattedMessageRecord)(intl, {
        events,
        label: messages.nyha,
        query: queries_1.queries.nyhaStage,
        messages: nyha_1.stageMessages
    });
}
function create6mwt(intl, { events }) {
    const { formatMessage } = intl;
    const ableToEvent = (0, events_1.findLastEventByQuery)(events, queries_1.queries.ableTo6mwt);
    if (ableToEvent === undefined) {
        return undefined;
    }
    if (ableToEvent.value === _6Mwt_1.AbleTo6mwt.NO) {
        const { timestamp, sid, origin } = ableToEvent;
        return {
            type: "record",
            attachments: (0, events_1.mapEventsToAttachments)(ableToEvent),
            value: formatMessage(messages.notAbleTo6mwt),
            label: formatMessage(messages["6mwt"]),
            timestamp,
            sid,
            origin
        };
    }
    const event = (0, events_1.findLastEventByQuery)(events, queries_1.queries["6mwt"]);
    if (event === undefined) {
        return undefined;
    }
    const { value, schema: { unit } = {}, timestamp, sid, origin } = event;
    return {
        type: "record",
        attachments: (0, events_1.mapEventsToAttachments)(event),
        variant: "short",
        label: formatMessage(messages["6mwt"]),
        value: (0, common_1.appendUnit)(value, unit),
        timestamp,
        sid,
        origin
    };
}
function createHospitalizations(intl, { events }) {
    return (0, shared_1.createNumberRecord)(intl, {
        events,
        label: messages.hospitalizations,
        query: queries_1.queries.hospitalizations
    });
}
function createPacemakerTherapy(intl, { events }) {
    return (0, shared_1.createFormattedMessageRecord)(intl, {
        events,
        label: messages.pacemakerTherapy,
        query: queries_1.queries.pacemakerTherapy,
        messages: pacemakerTherapy_1.valueMessages
    });
}
function createCoronarography(intl, { events }) {
    return (0, shared_1.createStringRecord)(intl, {
        events,
        variant: "long",
        label: messages.coronarography,
        query: queries_1.queries.coronarography
    });
}
function createCCt(intl, { events }) {
    return (0, shared_1.createStringRecord)(intl, {
        events,
        variant: "long",
        label: messages.cCt,
        query: queries_1.queries.cCt
    });
}
function createCMri(intl, { events }) {
    return (0, shared_1.createStringRecord)(intl, {
        events,
        variant: "long",
        label: messages.cMri,
        query: queries_1.queries.cMri
    });
}
function createSpect(intl, { events }) {
    return (0, shared_1.createStringRecord)(intl, {
        events,
        variant: "long",
        label: messages.spect,
        query: queries_1.queries.spect
    });
}
function createCPet(intl, { events }) {
    return (0, shared_1.createStringRecord)(intl, {
        events,
        variant: "long",
        label: messages.cPet,
        query: queries_1.queries.cPet
    });
}
